import { defineStore } from "pinia";

// Модалка "Следующий твой" (#ПриветEcoway) - открывается из шапки раздела
// Live и по прямой ссылке /hello/join (QR на локации). Монтируется один
// раз в App.vue, следит за `isOpen`. Работает без регистрации; если
// пользователь авторизован, бэкенд сам сохранит авторство по токену.
export const useHelloFeedWaveStore = defineStore("helloFeedWave", {
  state: () => ({
    isOpen: false,
    // id ноды, с которой пришла заявка - заполняется только при открытии по
    // прямой ссылке /hello/join?node=<id> (QR-код на конкретной ноде, см.
    // App.vue). Открытие из шапки Live (без QR-контекста) оставляет null -
    // HelloFeedWaveDialog.vue отправляет его как скрытое поле формы.
    nodeId: null as number | null,
  }),
  actions: {
    open(nodeId: number | null = null) {
      this.isOpen = true;
      this.nodeId = nodeId;
    },
    close() {
      this.isOpen = false;
      this.nodeId = null;
    },
  },
});
